/*
  Warteliste im Varianten-Picker: "Erinnere mich" waehlt die ausverkaufte Sorte (Klick auf die Option).
  Danach oeffnen wir das Klaviyo-Formular, indem wir den von Klaviyo eingeblendeten Button "Benachrichtige mich ..." klicken.
  Ersetzt die alte rememberme()-Funktion, die den (versteckten) Theme-Link .klaviyo-bis-trigger anklickte -
  den bediente das entfernte onsite.js.
*/
(function () {
  if (window.__sinobBisOpen) return;
  window.__sinobBisOpen = true;

  function findButton() {
    var list = document.querySelectorAll('button[class*="kl-private"]');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (/benachrichtige/i.test(b.textContent) && b.getBoundingClientRect().width > 0) return b;
    }
    return null;
  }

  window.rememberme = function () {
    var tries = 0;
    function attempt() {
      var b = findButton();
      if (b) { b.click(); return; }
      if (tries++ < 24) setTimeout(attempt, 250);
    }
    /* kurz warten: erst muss die Sorte gewaehlt und Klaviyos Button neu gerendert sein */
    setTimeout(attempt, 500);
  };
})();
